import { render } from "./AttachVMWithName.vue?vue&type=template&id=55b7d207"
import script from "./AttachVMWithName.vue?vue&type=script&lang=js"
export * from "./AttachVMWithName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__